import { Image } from '@/shared/ui/Image'

import { CDN_SPLIT_IMG_URL } from '../../data'

import cls from './style.module.scss'

export const SplitSteps = () => (
	<div className={cls.splitSteps}>
		<div className={cls.splitSteps__image}>
			<Image width={408} height={230} src={`${CDN_SPLIT_IMG_URL}/img.png`} alt="split steps" />
		</div>
		<div className={cls.splitSteps__steps}>
			<div className={cls.splitSteps__stepsItem}>
				<p>1</p>
				<p>Выберите Яндекс Сплит</p>
				<p>
					при оформлении заказа <br /> в способах оплаты
				</p>
			</div>
			<div className={cls.splitSteps__stepsItem}>
				<p>2</p>
				<p>Оплатите</p>
				<p>Выбирайте удобный Сплит</p>
			</div>
		</div>
	</div>
)
